import './ManageSubscription.scss';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { SubscriptionInfoPlaceholder, TravelerListPlaceholder } from '../../../components/skeleton-placeholder';
import { NoItemFound } from '../../../components/no-data-found';
import { CancelSubscriptionService, getPaymentHistoryListService, getSubscriptionPlanByIdApi } from '../../../services/AdminService';
import ConfirmModal from '../../../components/confirm-modal';
import { getPaymentStatus, getSubscriptionStatus } from '../../../helpers';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Invoice from '../../../components/pdf-view/Invoice';
import { PagePagination } from '../../../components/pagination';


const ManageSubscription = () => {
    const { authed } = useAuth();
    const history = useHistory();
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
    const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);
    const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [subscriptionData, setSubscriptionData] = useState();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pageInfo, setPageInfo] = useState({
        page: 1,
        pageSize: 8,
        totalItems: 0,
    });

    const getSubscriptionPlanById = async () => {
        setIsLoadingSubscription(true);
        await getSubscriptionPlanByIdApi({ userId: authed?.user?._id }, async (res) => {
            // console.log("getSubscriptionPlanById res.data===>,", res.data)
            setIsLoadingSubscription(false);
            if (res.status === 200) {
                setSubscriptionData(res.data.subscription);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const getPaymentHistoryList = async (pageData) => {
        setIsLoadingHistory(true);
        await getPaymentHistoryListService(pageData, (res) => {
            setIsLoadingHistory(false);
            if (res.status === 200) {
                // console.log("payment history list Data==>", res.data);
                const { invoiceList, paginationData } = res.data;
                setPaymentHistory(invoiceList);
                setPageInfo((prev) => ({
                    ...prev,
                    pageSize: paginationData.pageSize,
                    totalItems: paginationData.totalItems,
                }));
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const handleCancelSubscription = async () => {
        setIsLoadingConfirm(true);
        const dataObj = {
            priceId: subscriptionData.priceId,
            productId: subscriptionData.productId
        }
        await CancelSubscriptionService(dataObj, (res) => {
            setIsLoadingConfirm(false);
            if (res.status === 200) {
                // console.log("Cancel Subscription Service Data==>", res.data);
                getSubscriptionPlanById();
                setShowConfirmModal(false);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const onChangePaginate = (number) => {
        setPageInfo((prev) => {
            const updatedPageInfo = { ...prev, page: number };
            getPaymentHistoryList(updatedPageInfo);
            return updatedPageInfo;
        });
    };

    useEffect(() => {
        getPaymentHistoryList(pageInfo);
        getSubscriptionPlanById();
    }, []);

    // console.log("subscriptionData===>", subscriptionData)

    return (
        <>
            <div className="content-body">
                <div className="mt-header-block mb-3">
                    <h1 className="d-col-title">Plan Overview</h1>
                </div>
                <div className='row'>
                    {isLoadingSubscription ? (
                        <SubscriptionInfoPlaceholder number={1} />
                    ) : (
                        <>
                            <div className='col-md-5'>
                                <div className="card card-style-ms">
                                    <div className="card-header">
                                        Current Plan
                                    </div>
                                    <ul className="list-group list-group-flush">
                                        {subscriptionData?.status ? (
                                            <>
                                                <li className="list-group-item">
                                                    <span>Plan</span>
                                                    <span>{subscriptionData?.title || "N/A"}</span>
                                                </li>
                                                {subscriptionData?.title && subscriptionData.title !== "Beginning" && (
                                                    <>
                                                        <li className="list-group-item">
                                                            <span>Terms</span>
                                                            <span className='text-uppercase'>
                                                                {subscriptionData?.amount && subscriptionData?.interval ?
                                                                    <>
                                                                        {subscriptionData?.currency}
                                                                        &nbsp;
                                                                        {subscriptionData?.amount}
                                                                        &nbsp;/&nbsp;
                                                                        <span className='text-capitalize'>{subscriptionData?.interval}</span>
                                                                    </> : "N/A"}
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item">
                                                            <span>Amount</span>
                                                            <span className='text-uppercase'>{subscriptionData?.currency && subscriptionData?.amount ? subscriptionData?.currency + " " + subscriptionData?.amount : "N/A"}</span>
                                                        </li>
                                                        <li className="list-group-item">
                                                            <span>Status</span>
                                                            {subscriptionData?.status ? <span className='text-success'>Active</span> : <span className='text-danger'>Inactive</span>}
                                                        </li>
                                                        <li className="list-group-item">
                                                            <span>Start date</span>
                                                            <span>{subscriptionData?.current_period_start ? moment.unix(subscriptionData?.current_period_start).format('MMMM DD, YYYY') : "N/A"}</span>
                                                        </li>
                                                        <li className="list-group-item">
                                                            <span>Renewal date</span>
                                                            <span>{subscriptionData?.current_period_end ? moment.unix(subscriptionData?.current_period_end).format('MMMM DD, YYYY') : "N/A"}</span>
                                                        </li>
                                                    </>
                                                )}
                                                <li className="list-group-item">
                                                    <span></span>
                                                    {subscriptionData?.status && subscriptionData?.title && subscriptionData.title !== "Beginning" ? (
                                                        <div className='list-group-btn'>
                                                            <button type='button' className='btn btn-primary-color btn-cs' onClick={() => setShowConfirmModal(true)}>Cancel Plan</button>
                                                            {getSubscriptionStatus(subscriptionData, 7)?.status === "expired" || getSubscriptionStatus(subscriptionData, 7)?.status === "warning" && (
                                                                <button type='button' className='btn btn-primary-color btn-cs ms-2'>Renew</button>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <button type='button' className='btn btn-primary-color btn-cs' onClick={() => history.push("/subscriptions")}>Upgrade Plan</button>
                                                    )}
                                                </li>
                                            </>
                                        ) : (
                                            <li className="list-group-item">
                                                <span>Not Subscribed.</span>
                                                <button type='button' className='btn btn-primary-color btn-cs' onClick={() => history.push("/subscriptions")}>Upgrade Plan</button>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <h5 className='mb-3 mt-4 cs-subtitle'>Plan Orders</h5>
                {isLoadingHistory ? (
                    <div className="mt-table-wrap table-responsive">
                        <TravelerListPlaceholder number={4} />
                    </div>
                ) : (
                    <>
                        <div className="mt-table-wrap table-responsive">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Transaction ID</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Created on</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" className="text-right">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentHistory.length > 0 ? paymentHistory.sort((a, b) => new Date(b.created) - new Date(a.created)).map((item, i) => {
                                        const index = (pageInfo.page - 1) * pageInfo.pageSize + i + 1;
                                        return (
                                            <>
                                                <tr key={item.id}>
                                                    <td>{index}</td>
                                                    <td className='col-4'>{item?.id || ""}</td>
                                                    <td className='col-2'><span className='text-uppercase'>{item?.currency || ""}</span> {Number(item?.amount) || ""} </td>
                                                    <td className='col-3'>{moment.unix(item?.time).format('MMMM DD, YYYY hh:mm A') || ""}</td>
                                                    <td className='col-2'><span className='text-success text-capitalize'>{getPaymentStatus(item?.status) || ""}</span></td>
                                                    <td className="mt-btn-groups col-1">
                                                        {item?.paymentType === "paypal" ? (
                                                            <PDFDownloadLink className="btn d-inline-flex align-items-center justify-content-center" document={<Invoice invoiceData={item} />} fileName={"Invoice" + item?.id + ".pdf"}>
                                                                {({ blob, url, loading, error }) => (
                                                                    <i className="bi bi-download"></i>
                                                                )}
                                                            </PDFDownloadLink>
                                                        ) : (
                                                            <a href={item?.invoice} download className="btn d-inline-flex align-items-center justify-content-center">
                                                                <i className="bi bi-download"></i>
                                                            </a>
                                                        )}
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    }) :
                                        <tr>
                                            <td colSpan={6}><NoItemFound /></td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {paymentHistory.length > 0 && (
                    <PagePagination
                        totalItems={pageInfo.totalItems}
                        currentPage={pageInfo.page}
                        pageSize={pageInfo.pageSize}
                        onPageChange={onChangePaginate}
                        loading={isLoadingHistory}
                    />
                )}
            </div>
            <ConfirmModal
                messageTxt={"Are you sure you want to cancel your subscription?"}
                showConfirmModal={showConfirmModal}
                setShowConfirmModal={setShowConfirmModal}
                isLoading={isLoadingConfirm}
                confirmFnc={handleCancelSubscription}
            />
        </>
    );
}

export default ManageSubscription;